// extracted by mini-css-extract-plugin
export default {"term":"c3WUg_ZaQ","priceContainer":"cgZykQLXo","currency":"ctGAvACXW","discount":"cLRub_gdP","monthlyDiscountPrice":"cRSTbSDc4","optionContainer":"cj9lLBWfL"};